import { FilterEffects } from './filter.effects';
import { UserEffects } from './user.effects';
import { DeliveryEffects } from './delivery.effects';
import { DeliveryAssetEffects } from './delivery-asset.effects';
import { AuthEffects } from './auth.effects';
import { AccountSettingsEffects } from './account-settings.effects';
import { OfflineEffects } from './offline.effects';
import { OfflineStatusEffects } from './offline-statuses.effects';
import { ApplicationSetiingsEffects } from 'app/settings/application-settings/store/application-settings.effects';

export const effects: any[] = [
  AuthEffects,
  UserEffects,
  DeliveryAssetEffects,
  DeliveryEffects,
  AccountSettingsEffects,
  OfflineEffects,
  OfflineStatusEffects,
  ApplicationSetiingsEffects,
  FilterEffects,
];

export * from './auth.effects';
export * from './user.effects';
export * from './offline.effects';
